import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {IQueryParam} from "../../Apis/Models/IQueryParams";
import useFilteredList from "../../Hooks/UseFilteredList";
import Label from "Components/Label";
import Select from "Components/Select";
import {useSettlementProjects} from "../../Apis/ProjectSettlementApi";

interface Fields {
    [key: string]: IQueryParam;
}
interface IProps {
    filterUpdated: (params: Fields, resetParams: boolean) => void;
    currentValue: Fields;
}
const ProjectSettlementListFilter = (props: IProps) => {

    const { filterUpdated, currentValue } = props;

    const { t } = useTranslation();

    const { data: projects } = useSettlementProjects();

    const [ query, setQuery ] = useState<Fields>({});

    useEffect(() => {
        setQuery(currentValue);
    }, [currentValue]);

    const [ filteredProjects, setProjectFilter, projectFilterValue ] = useFilteredList(projects ?? [], x => [x.name]);

    const setQueryField = (fieldName: 'projectId', value: IQueryParam) => {
        const newValue = {...query, [fieldName]: value }
        setQuery(newValue);
        filterUpdated(newValue, true);
    }

    return (
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(1, 1fr)', gap: 20}}>
            <div>
                <Label placeholder={t('project')}/>
                <Select name={"projectId"} value={query['projectId']} onChange={value => setQueryField('projectId', value)} onFilter={setProjectFilter}>
                    {!projectFilterValue && (
                        <Select.Option value={undefined} label={t('all')}/>
                    )}
                    {filteredProjects?.map(project => <Select.Option key={project.id} value={project.id} label={project.name}/>)}
                </Select>
            </div>
        </div>
    )

}

export default ProjectSettlementListFilter